import { t } from "i18next";
import profile from "../../../assets/logos/logo_only.png";
import { useTranslation } from "react-i18next";
const DisplayProfileCard = ({ name, fin, verified, photo }) => {
    const { i18n } = useTranslation();
    return (
        <div className='rounded-md overflow-clip w-full shadow-lg h-full min-h-[200px]'>
            <div className='h-full flex flex-wrap justify-center items-center bg-MetallicBlue px-5 gap-5 text-white py-5'>
                <div className='flex h-fit justify-center items-center min-w-[180px] max-w-[180px] aspect-square w-full rounded-full bg-white overflow-hidden'>
                    <img
                        src={
                            photo !== ""
                                ? `data:image/jpeg;base64,${photo}`
                                : profile
                        }
                        alt='profile'
                        className='w-full h-full object-contain'
                    />
                </div>
                <div className='flex flex-col gap-2 justify-center'>
                    <p>
                        {t("welcome")},{" "}
                        <span className='font-bold text-2xl'>
                            {i18n.language === "amh"
                                ? name?.amh?.split(" ")[0]
                                : name?.eng?.split(" ")[0]}
                        </span>
                    </p>
                    <p>{verified ? t("verified") : t("not-verified")}</p>
                    <p className='bg-gray-200 text-MetallicBlue px-2 min-w-fit rounded-full py-1 w-fit flex'>
                        <span className='font-bold'>FIN:</span>{" "}
                        <span>
                            {'*'.repeat(String(fin).length - 4) + String(fin).slice(-4)}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DisplayProfileCard;
